export default __webpack_public_path__ + "static/media/icon-coin-pendle.88f3aa81.svg";